import headerIcon from "../../../assets/images/avatar.svg";
import Dropdown from "react-bootstrap/Dropdown";
import "./header.component.scss";
import { useDispatch, useSelector } from "react-redux";
import { LogOut } from "../../../Redux/authSlice";
import {
  setLoaderFalse,
  setLoaderTrue,
  setLogoutLoading,
} from "../../../Redux/loaderSlice";
import { useEffect, useRef, useState } from "react";
import exportImages from "../../../assets/images/exportImages";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import group_3 from "../../../assets/images/in-progress/reseller_bank_img.svg";
import {
  resetOrgDetails,
  setHealthAnalysisID,
  setOrgId,
  setOrgKey,
  setOrgName,
} from "../../../Redux/orgDetailsSlice";
import Container from "react-bootstrap/Container";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { resetHID } from "../../../Redux/mainReportSlice";
import ClickOutside from "../ClickOutside";
import ListOptions from "../ListOptions";
import { breadcrumHistory } from "../../../Redux/navigationHistorySlice";
import { UpgradeCardSpecificModal } from "../Popup/UpgradeCardPopUp/UpgradeCard";
import { cardUpgradeData } from "../../../utils/upgradeCardsDetailedInfo";
import RecursiveCall from "./RecursiveCall";
import { bondScoreAnalysisSlice } from "../../../rtk-query/features/dashboard/bondScore/bondScoreAnalysisSlice";
import { setSkipFHSAPICall } from "../../../rtk-query/features/dashboard/financialHealthScore/financialHealthScoreAnalysisSlice";
import { paymentSuccessfulData } from "../Popup/ImageAndDataPopUp/DataContent";
import { ImageAndDataPopUp } from "../Popup/ImageAndDataPopUp/ImageAndDataPopUp";
import { SUBSCRIPTION, USER_TYPE } from "../../../utils/global";
import {
  setHomeClicked,
  setInfiniteBankPerformanceMetricsSlice,
} from "../../../rtk-query/features/infiniteBankPerformanceMetricsSlice/infiniteBankPerformanceMetricsSlice";
import { resetCampaignHistoryReducerState } from "../../../Redux/campaignHistorySlice";
import { usePermissions } from "../../../hooks/usePermissions";
import { PRIVILEGES } from "../../../utils/privileges";
import { resetCampaignPaginationReducerState } from "../../../Redux/paginationSlice";
import { useSubscription } from "../../../hooks/useSubscription";
import {
  resetFISubscriptionPrivileges,
  setSubscriptionPrivileges,
} from "../../../Redux/privilegesSlice";
import Notification from "../Notification/Notification";
import {
  notificationRTK,
  useGetNotificationListQuery,
} from "../../../rtk-query/features/usernotification/notificationRTK";
import BannerNotification from "../Notification/BannerNotification";
import { setShowBannerNotification } from "../../../rtk-query/features/usernotification/notificationSlice";
import {
  resetSelectedQuarter,
  setQuarterList,
  setSelectedQuarter,
} from "../../../rtk-query/features/downloadFHSReport/downloadFHSReportSlice";
import { clearChat, resetChatbotHistory } from "../../../rtk-query/features/chatbot/chatbotSlice";
import { insightsAndRecommendationSlice } from "../../../rtk-query/features/insightsAndRecommendation/insightsAndRecommendationSlice";
import { initialFilterDataSlice } from "../../../Redux/initialFilterDataSlice";
import { registrationSlice } from "../../../rtk-query/features/auth/register/registrationSlice";
import { autoPilotLookupsSlice } from "../../../rtk-query/features/campaign/email-campaign/autopilotLookupsSlice";
import { cohortRTK } from "../../../rtk-query/features/cohort/cohortRTK";
import { consumerDemographicsAnalysisSlice } from "../../../rtk-query/features/dashboard/consumerDemographics/consumerDemographicsAnalysisSlice";
import { efficiencyRatioAnalysisSlice } from "../../../rtk-query/features/dashboard/efficiencyRatio/efficiencyRatioAnalysisSlice";
import { fileAnalyticsAnalysisSlice } from "../../../rtk-query/features/dashboard/fileAnalytics/fileAnalyticsAnalysisSlice";
import { ghostConsumerAnalysisSlice } from "../../../rtk-query/features/dashboard/ghostConsumer/ghostConsumerAnalysisSlice";
import { missedRevenueAnalysisSlice } from "../../../rtk-query/features/dashboard/missedRevenue/missedRevenueAnalysisSlice";
import { missingProductsAnalysisSlice } from "../../../rtk-query/features/dashboard/missingProducts/missingProductsAnalysisSlice";
import { newUserGrowthAnalysisSlice } from "../../../rtk-query/features/dashboard/newUserGrowth/newUserGrowthAnalysisSlice";
import { opportunitiesAnalysisSlice } from "../../../rtk-query/features/dashboard/opportunities/opportunitiesAnalysisSlice";
import { secondaryConsumerAnalysisSlice } from "../../../rtk-query/features/dashboard/secondaryConsumer/secondaryConsumerAnalysisSlice";
import { topCompetitorsAnalysisSlice } from "../../../rtk-query/features/dashboard/topCompetitors/topCompetitorsAnalysisSlice";
import { topMerchantsAnalysisSlice } from "../../../rtk-query/features/dashboard/topMerchants/topMerchantsAnalysisSlice";
import { topPersonaAnalysisSlice } from "../../../rtk-query/features/dashboard/topPersona/topPersonaAnalysisSlice";
import { bondScoreTrendSlice } from "../../../rtk-query/features/dashboard/trends/bondScoreTrendSlice";
import { ghostConsumersTrendSlice } from "../../../rtk-query/features/dashboard/trends/ghostConsumersTrendSlice";
import { missingRevenueTrendSlice } from "../../../rtk-query/features/dashboard/trends/missingRevenueTrendSlice";
import { opportunitiesTrendSlice } from "../../../rtk-query/features/dashboard/trends/opportunitiesTrendSlice";
import { secondaryConsumersTrendSlice } from "../../../rtk-query/features/dashboard/trends/secondaryConsumersTrendSlice";
import {
  downloadFHSReportRTK,
  useGetDownloadReportQuarterListQuery,
} from "../../../rtk-query/features/downloadFHSReport/downloadFHSReportRTK";
import { getDateMonthYearFormat } from "../../Bank/CampaignManagement/campaignConstant";
import moment from "moment";

const menuItems = [
  {
    label: "Email Templates",
    navUrl: "/bank/campaign-management/email-templates",
    privilege: PRIVILEGES.SHOW_EMAIL_TEMPLATE_MANAGEMENT,
  },
  {
    label: "Email Campaign",
    navUrl: "/bank/campaign-management/email-campaigns",
    privilege: PRIVILEGES.SHOW_EMAIL_CAMPAIGN_MANAGEMENT,
  },
  {
    label: "SMS Campaign",
    navUrl: "/bank/campaign-management/SMS_campaigns",
    privilege: PRIVILEGES.SHOW_SMS_CAMPAIGN_MANAGEMENT,
  },
  {
    label: "Consumer Lists",
    navUrl: "/bank/campaign-management/consumers-list",
    privilege: PRIVILEGES.SHOW_CONSUMER_LIST_MANAGEMENT,
  },
];

export const Header = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();
  const [showCampaigns, setShowCampaigns] = useState(false);
  const forceLogout = useSelector((state) => state.stripeReducer.forceLogout);
  const loaderReducer = useSelector((state) => state.loaderReducer);
  const authReducer = useSelector((state) => state.authReducer);
  const showBannerNotification = useSelector(
    (state) => state.notificationReducer.showBannerNotification,
  );
  const navigationHistoryReducer = useSelector(
    (state) => state.navigationHistoryReducer,
  );
  const userRole = authReducer?.userData?.role?.toLowerCase();
  const subscription = authReducer?.userData?.subscription?.toLowerCase();
  const isFirstLogin = authReducer?.userData?.isFirstLogin;
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location?.pathname);
  const [BankNavLink] = useState(false);
  const [toggleOverlay, setToggleOverlay] = useState(false);
  const [upgradeCardModal, setUpgradeCardModal] = useState(false);
  const [selectedCardData, setSelectedCardData] = useState();
  const [showDropdown, setShowDropdown] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);
  const profileBoxRef = useRef();

  const [fullName, setFullName] = useState(
    `${authReducer?.userData?.firstName}` +
    " " +
    `${authReducer?.userData?.lastName}`,
  );

  const checkEWI = useSelector((state) => state?.ewiReducer?.isEWIExist);
  const [EWIexist, setEWIexist] = useState(false);

  const subscriptionReducer = useSelector((state) => state.subscriptionReducer);
  const isFhsAvailable = subscriptionReducer?.isFhsAvailable;
  const isPro = subscriptionReducer?.isPro;
  const isMarketing = subscriptionReducer?.isMarketing;



  // const {
  //   data: quarterListArray,
  //   isLoading,
  //   isFetching,
  //   isError,
  //   error,
  //   refetch,
  // } = useGetDownloadReportQuarterListQuery(_, {});

  // useEffect(() => {
  //   if (quarterListArray) {
  //     let dropdownItems = quarterListArray?.map((item, index) => ({
  //       label: item,
  //       code: index === 0 ? "current" : item,
  //     }));

  //     dispatch(
  //       setSelectedQuarter(
  //         dropdownItems?.[0] != null
  //           ? dropdownItems?.[0]
  //           : { label: "", code: "current" },
  //       ),
  //     );
  //     dispatch(setQuarterList(dropdownItems));
  //   }
  // }, [quarterListArray]);

  useEffect(() => {
    if (!window.location.href.includes("campaign-management")) {
      dispatch(resetCampaignHistoryReducerState(null));
    }
  });

  useEffect(() => {
    setFullName(
      `${authReducer?.userData?.firstName}` +
      " " +
      `${authReducer?.userData?.lastName}`,
    );
  }, [authReducer?.userData?.firstName, authReducer?.userData?.lastName]);

  useEffect(() => {
    if (BankNavLink === true) {
      setCurrentPath("none");
    } else {
      setCurrentPath(location.pathname);
    }
  });

  useEffect(() => {
    if (isFirstLogin && !authReducer?.userContactedSales) {
      const selectedCard = cardUpgradeData.find(
        (card) => card.name === "first_time_logged_in",
      );
      setUpgradeCardModal(true);
      setSelectedCardData(selectedCard);
    }
    setEWIexist(checkEWI);
  }, []);

  const cacheImages = async (srcArray) => {
    const promises = await srcArray.map((src) => {
      return new Promise(function (resolve, reject) {
        const img = new Image();
        img.src = src;
        img.onload = resolve();
        img.onerror = reject();
      });
    });
    await Promise.all(promises);
  };

  const { data } = useGetNotificationListQuery(_, {
    skip: !hasSubscription(PRIVILEGES.SHOW_BANNER_NOTIFICATION),
  });
  const notificationList = data?.data;

  const [newAnalysis, setNewAnalysis] = useState(null);

  useEffect(() => {
    if (notificationList?.length > 0) {
      const newAnalysisNotification = notificationList?.find(
        (n) =>
          n?.type === "analysis" &&
          n?.notifiableType === "New Data Available" &&
          (!n?.readAt || n?.readAt === ""),
      );
      if (
        orgReducer?.healthAnalysisID?.uid != null &&
        orgReducer?.healthAnalysisID?.uid !== "no-analysis-id"
      ) {
        setShowBannerNotification(true);
      } else {
        dispatch(
          setShowBannerNotification(
            newAnalysisNotification != null ? true : false,
          ),
        );
      }

      setNewAnalysis(
        newAnalysisNotification != null ? newAnalysisNotification : null,
      );
    }
  }, [notificationList]);

  useEffect(() => {
    setHasUnread(notificationList?.some((item) => item.readAt === null));
  }, [notificationList]);

  useEffect(() => {
    const imgs = [
      exportImages.missed_revenue_upgrade,
      exportImages.uplift_loans_upgrade,
      exportImages.boost_deposits_upgrade,
      exportImages.beat_the_competition_upgrade,
      exportImages.automated_marketing_upgrade,
      exportImages.contact_sales_team_upgrade,
      exportImages.contact_sales_team_success_upgrade,
      exportImages.consumer_behavior_upgrade,
      exportImages.insights_popup_bgimg,
      exportImages.mobile_static_img,
      exportImages.power_button,
      exportImages.power_button_blue,
      exportImages.icons_privacy_policy,
      exportImages.icons_privacy_policy_blue,
      exportImages.icons_settings,
      exportImages.icons_settings_bule,
      exportImages?.icon_role_star,
      exportImages.list_icon_view_details,
      exportImages.list_icon_approve,
      exportImages.list_icon_eye,
      exportImages.list_icon_trash,
      exportImages.list_icon_edit_grey,
      exportImages.list_icon_speed_test,
      exportImages.list_icon_edit,
      exportImages.list_icon_delete,
      exportImages.speedtest,
      exportImages.gauge_blue,
      exportImages.gauge_white,
      exportImages.trend_blue,
      exportImages.trend_white,
      group_3,
    ];
    cacheImages(imgs);
  }, []);

  const handleDropdownToggle = async (isOpen) => {
    if (loaderReducer?.performaLoading) {
      setShowDropdown(false); // block open while loading
      return;
    }
    setShowDropdown(isOpen);
  };

  const toggleButton = (
    <div className="d-flex">
      <div className="btn btn-icon btn-sm btn-active-bg-accent d-lg-none ms-1 ms-lg-6">
        <span className="svg-icon svg-icon-1 svg-icon-dark">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
              fill="black"
            />
            <path
              opacity="0.3"
              d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
              fill="black"
            />
          </svg>
        </span>
      </div>
      <div onClick={(e) => e.stopPropagation()}></div>
    </div>
  );

  const changeNavLink = (item) => {
    if (item?.label === "Home") {
      dispatch(setHomeClicked(true));
      if (userRole === USER_TYPE.RESELLER.toLocaleLowerCase() || userRole === USER_TYPE.SUPER_ADMIN.toLocaleLowerCase()) {
        dispatch(resetOrgDetails());
      }
      dispatch(
        setSubscriptionPrivileges(authReducer.userData.product_Privileges),
      );
      dispatch(resetFISubscriptionPrivileges());
    }
    setCurrentPath(location.pathname);
    props.setNavBar(false);
    dispatch(resetCampaignPaginationReducerState(null));
    dispatch(
      breadcrumHistory({
        cardName: "",
        currentPath: location.pathname,
        checkPathFromCluster: false,
        hid: "",
        isSettingPageOptionClick: false,
      }),
    );
    dispatch(resetSelectedQuarter());
  };

  //This is to clear the RTK slice
  const resetAllApiState = () => (dispatch) => {
    dispatch(bondScoreAnalysisSlice.util.resetApiState());
    dispatch(insightsAndRecommendationSlice.util.resetApiState());
    dispatch(initialFilterDataSlice.util.resetApiState());
    dispatch(registrationSlice.util.resetApiState());
    dispatch(autoPilotLookupsSlice.util.resetApiState());
    dispatch(cohortRTK.util.resetApiState());
    dispatch(consumerDemographicsAnalysisSlice.util.resetApiState());
    dispatch(efficiencyRatioAnalysisSlice.util.resetApiState());
    dispatch(fileAnalyticsAnalysisSlice.util.resetApiState());
    dispatch(ghostConsumerAnalysisSlice.util.resetApiState());
    dispatch(missedRevenueAnalysisSlice.util.resetApiState());
    dispatch(missingProductsAnalysisSlice.util.resetApiState());
    dispatch(newUserGrowthAnalysisSlice.util.resetApiState());
    dispatch(opportunitiesAnalysisSlice.util.resetApiState());
    dispatch(secondaryConsumerAnalysisSlice.util.resetApiState());
    dispatch(topCompetitorsAnalysisSlice.util.resetApiState());
    dispatch(topMerchantsAnalysisSlice.util.resetApiState());
    dispatch(topPersonaAnalysisSlice.util.resetApiState());
    dispatch(bondScoreTrendSlice.util.resetApiState());
    dispatch(ghostConsumersTrendSlice.util.resetApiState());
    dispatch(missingRevenueTrendSlice.util.resetApiState());
    dispatch(opportunitiesTrendSlice.util.resetApiState());
    dispatch(secondaryConsumersTrendSlice.util.resetApiState());
    dispatch(downloadFHSReportRTK.util.resetApiState());
    dispatch(notificationRTK.util.resetApiState());
    dispatch(cohortRTK.util.resetApiState());
    // add all RTK APIs here
  };

  const LogoutHandler = () => {
    dispatch(setSkipFHSAPICall(true));
    dispatch(setLogoutLoading(true));
    dispatch(setLoaderTrue());
    dispatch(setOrgId(""));
    dispatch(setOrgName(""));
    dispatch(setOrgKey(""));
    dispatch(resetHID());
    dispatch(setHealthAnalysisID(null));
    dispatch(setInfiniteBankPerformanceMetricsSlice());
    dispatch(resetChatbotHistory());
    dispatch(resetSelectedQuarter());
    dispatch(clearChat());
    dispatch(resetAllApiState());


    const scriptElement = document.querySelector(
      'script[src="./Bond_Component.js"]',
    );
    scriptElement?.remove();
    localStorage.clear();
    dispatch(resetCampaignPaginationReducerState(null));
    setTimeout(async () => {
      await dispatch(LogOut())
        .unwrap()
        .then(() => {
          dispatch(setLoaderFalse());
          navigate("/user/login");
        })
        .catch((err) => {
          dispatch(setLoaderFalse());
        });
    }, 2000);
  };

  const [expanded, setExpanded] = useState(false); // Use state to toggle Navbar expansion
  const orgReducer = useSelector((state) => state.orgReducer);

  const hasOrgClientId = Boolean(orgReducer?.selectedFI?.orgClientId);

  const toggleNavbar = () => {
    setExpanded(!expanded);
  };

  const handleEmailCampaignsMenuClick = (event, selectedMenu) => {
    event.preventDefault();
    if (!hasSubscription(selectedMenu?.privilege)) {
      return navigate("/bank/campaign-management/campaign-management-locked", {
        state: {
          selectedMenu,
        },
      });
    }
    navigate(selectedMenu?.toUrl);
    setToggleOverlay(false);
    dispatch(resetCampaignPaginationReducerState(null));
    dispatch(
      breadcrumHistory({
        cardName: "",
        currentPath: location.pathname,
        checkPathFromCluster: false,
        hid: "",
        isSettingPageOptionClick: false,
      }),
    );
  };

  const handleClickSettings = () => {
    navigate("/pages/settings");
    if (
      userRole?.toLowerCase() === USER_TYPE.RESELLER.toLowerCase() ||
      userRole?.toLowerCase() === USER_TYPE.SUPER_ADMIN.toLowerCase()
    ) {
      dispatch(
        breadcrumHistory({
          cardName: "",
          currentPath: location.pathname,
          checkPathFromCluster: false,
          hid: "",
          isSettingPageOptionClick: true,
        }),
      );
    }
  };

  const menuItems = [
    {
      label: "Home",
      toUrl:
        userRole === "reseller" || userRole === "bond-admin"
          ? `/user/bankperformancemetrics`
          : subscription === SUBSCRIPTION.ANALYST
            ? EWIexist
              ? `/bank/health-analysis/report/${authReducer?.userData?.idrssd}/financial-health-score`
              : "bank/EWI_under_maintenance"
            : `/bank/health-analysis/report/${orgReducer?.healthAnalysisID?.uid
              ? orgReducer?.healthAnalysisID?.uid
              : "no-analysis-id"
            }`,
      privilege: [],
      subMenu: null,
    },
    {
      label: "History",
      toUrl: "/bank/health-analysis/history",
      privilege: PRIVILEGES.SHOW_HISTORY_PAGE,
      hidePrivilege: PRIVILEGES.HIDE_HISTORY_PAGE,
      subMenu: null,
    },
    {
      label: "Campaigns",
      privilege: PRIVILEGES.SHOW_CAMPAIGN_MANAGEMENT,
      hidePrivilege: PRIVILEGES.HIDE_CAMPAIGN_MANAGEMENT,
      subMenu: [
        {
          label: "Email Templates",
          toUrl: "/bank/campaign-management/email-templates",
          privilege: PRIVILEGES.SHOW_EMAIL_TEMPLATE_MANAGEMENT,
        },
        {
          label: "Email Campaign",
          toUrl: "/bank/campaign-management/email-campaigns",
          privilege: PRIVILEGES.SHOW_EMAIL_CAMPAIGN_MANAGEMENT,
        },
        {
          label: "SMS Campaign",
          toUrl: "/bank/campaign-management/SMS_campaigns",
          privilege: PRIVILEGES.SHOW_SMS_CAMPAIGN_MANAGEMENT,
        },
        {
          label: "Consumer Lists",
          toUrl: "/bank/campaign-management/consumers-list",
          privilege: PRIVILEGES.SHOW_CONSUMER_LIST_MANAGEMENT,
        },
      ],
    },
    {
      label: "Users",
      toUrl: "/bank/user-management/user-management-list",
      privilege:
        userRole?.toLowerCase() === USER_TYPE.RESELLER.toLowerCase() ||
          userRole?.toLowerCase() === USER_TYPE.SUPER_ADMIN.toLowerCase()
          ? []
          : PRIVILEGES.SHOW_USER_MANAGEMENT,
      hidePrivilege: PRIVILEGES.HIDE_USERS_MANAGEMENT,
      subMenu: null,
    },

    {
      label: "Support",
      toUrl: "/pages/faq",
      privilege: PRIVILEGES.SHOW_SUPPORT,
      hidePrivilege: PRIVILEGES.HIDE_SUPPORT,
      subMenu: null,
    },
  ];

  return (
    <>
      <RecursiveCall />
      <div className={`bond-header-container`}>
        <div
          className={`d-flex align-items-stretch justify-content-center fixed-header bond-header`}
        >
          <Navbar expand="lg" className="container fixed-header">
            <Container fluid>
              <Navbar.Brand>
                <div
                  className="aside-logo pe-2"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    className={`pe-4 ${![
                      "/user/bankperformancemetrics",
                      "/pages/faq",
                      "/user-management/user-management-list",
                    ].some((sub) => window.location.pathname.includes(sub)) ||
                      // userRole !== USER_TYPE.SUPER_ADMIN.toLowerCase() &&
                      (userRole?.toLowerCase() !==
                        USER_TYPE.RESELLER.toLowerCase() &&
                        userRole?.toLowerCase() !==
                        USER_TYPE.SUPER_ADMIN.toLowerCase())
                      ? "logo-right-border"
                      : ""
                      }`}
                    alt="Logo"
                    src={exportImages?.logo_black_img}
                  />

                  <span
                    className={`ps-4 fw-bolder fi-name-header`}
                    style={{
                      display: navigationHistoryReducer.isSettingPageOptionClick
                        ? "none"
                        : "block",
                    }}
                  >
                    {![
                      "/user/bankperformancemetrics",
                      "/pages/faq",
                      "/user-management/user-management-list",
                    ].some((sub) => window.location.pathname.includes(sub)) ||
                      // userRole !== USER_TYPE.SUPER_ADMIN.toLowerCase() &&
                      (userRole?.toLowerCase() !==
                        USER_TYPE.RESELLER.toLowerCase() &&
                        userRole?.toLowerCase() !==
                        USER_TYPE.SUPER_ADMIN.toLowerCase())
                      ? // ? transformBankName(orgReducer?.selectedFI?.org_name)
                      orgReducer?.selectedFI?.org_name
                      : ""}
                  </span>
                </div>
              </Navbar.Brand>
              <Navbar.Collapse id="navbarScroll">
                <Nav className="ms-auto d-flex align-items-center nav-container">
                  {/* {menuItems?.map((item) => {
                    if (
                      // (userRole?.toLowerCase() ===
                      //   USER_TYPE.ADMIN.toLowerCase() ||
                      //   userRole?.toLowerCase() ===
                      //     USER_TYPE.USER.toLowerCase()) &&
                      item?.hidePrivilege &&
                      hasSubscription(item?.hidePrivilege)
                    )  */}



                  {menuItems?.map((item) => {

                    const isDisabled = !hasOrgClientId;
                    if (
                      item?.hidePrivilege &&
                      hasSubscription(item?.hidePrivilege)
                    )
                      return null;
                    return (
                      hasPermission(item.privilege) &&
                      (hasSubscription(item.privilege) ? (

                        item.label === "Support" ? (
                          <NavLink
                            key={item.label}
                            to={isDisabled ? "#" : "/pages/faq"}
                            className={`menu-item-header ${isDisabled ? "disabled" : ""
                              }`}
                            style={{
                              pointerEvents: isDisabled ? "none" : "auto",
                              opacity: isDisabled ? 0.5 : 1,
                              cursor: isDisabled ? "not-allowed" : "pointer",
                              color: isDisabled ? "#6c757d" : "",
                              textDecoration: "none",
                            }}
                            onClick={(e) => {
                              if (isDisabled) e.preventDefault();
                              else changeNavLink(item);
                            }}

                          >
                            {item?.subMenu != null ? "" : item?.label}
                          </NavLink>
                        ) : (
                          <NavLink
                            to={item?.toUrl ?? window.location.href}
                            className={`menu-item-header ${item?.label === "Campaigns" &&
                              window.location.href.includes(
                                "/campaign-management/",
                              )
                              ? "active"
                              : ""
                              }`}
                            disabled
                            onClick={() => changeNavLink(item)}
                            onMouseEnter={() =>
                              item?.label === "Campaigns" &&
                              setShowCampaigns(true)
                            }
                            onMouseLeave={() =>
                              item?.label === "Campaigns" &&
                              setShowCampaigns(false)
                            }
                          >
                            {item?.subMenu != null ? "" : item?.label}
                            {item?.subMenu != null && (
                              <NavDropdown
                                title="Campaigns"
                                id="basic-nav-dropdown"
                                show={showCampaigns}
                              >
                                {item?.subMenu?.map((subItem) => {
                                  return (
                                    hasPermission(subItem.privilege) && (
                                      <NavDropdown.Item
                                        className="py-4 px-8"
                                        onClick={(e) =>
                                          handleEmailCampaignsMenuClick(
                                            e,
                                            subItem,
                                          )
                                        }
                                      >
                                        {subItem?.label}
                                      </NavDropdown.Item>
                                    )
                                  );
                                })}
                              </NavDropdown>
                            )}
                          </NavLink>
                        )
                      ) : (
                        <div className="menu-item-header disabled">
                          {item?.label}
                        </div>
                      ))
                    );
                  })}
                </Nav>
              </Navbar.Collapse>
              <Navbar.Toggle
                aria-controls={`navbarScroll`}
                children={toggleButton}
                style={{
                  alignSelf: "end",
                  textAlign: "left",
                  marginLeft: "auto",
                }}
                onClick={toggleNavbar}
              />

              <div className="d-flex align-items-center ">
                <div
                  style={{ display: "none" }}
                  className="dropdown notificationDropdown mx-5"
                >
                  <button
                    className="btn btn-icon btn-sm btn-active-bg-accent badge rounded-pill bg-light position-relative"
                    type="button"
                    id="dropdownMenuButton2"
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <img alt="icon" src={exportImages?.notification} />
                    <span className="position-absolute badge-number top-0 start-100 translate-middle p-2 btn-bond bg-success border border-light rounded-circle">
                      <span></span>
                    </span>
                  </button>

                  <ul
                    className="dropdown-menu p-0 w-300px w-xxl-400px"
                    aria-labelledby="dropdownMenuButton2"
                  >
                    <li className="dropdownTitle"> New Notifications </li>
                    <li>
                      <hr className="dropdown-divider m-0" />
                    </li>
                    <div className="notificationData">
                      <li>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0 w-35px w-xxl-50px">
                            <img
                              src="assets/images/icon_notification_bank_health_score.png"
                              className="img-fluid"
                              alt="icon_notification_bank_health_score.png"
                            />
                          </div>

                          <div className="flex-grow-1 ms-3">
                            <label className="title"></label>
                            <p className="mb-0 subTitle"></p>
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
                {/* <Dropdown
                  show={showDropdown}
                  className=" d-block d-sm-block d-md-block d-lg-block"
                  onToggle={handleDropdownToggle}
                >
                  <Dropdown.Toggle
                    className="btn btn-icon btn-sm btn-active-bg-accent"
                    id="dropdownMenuButton2"
                  >
                    <img
                      alt="icon"
                      src={exportImages?.icon_new_analysis_notification}
                      className="img-fluid position-relative"
                    />

                    <img
                      src={exportImages?.icon_notification_badge}
                      className="img-fluid position-absolute top-0"
                      style={{
                        right: "8px",
                        display: hasUnread ? "block" : "none",
                      }}
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="notification-dropdown user-dropdown">
                    <Notification LogoutHandler={LogoutHandler} />
                  </Dropdown.Menu>
                </Dropdown> */}

                <Dropdown className="userIconDropdown  d-block d-sm-block d-md-block d-lg-block  ">
                  <Dropdown.Toggle
                    className="btn btn-icon btn-sm btn-active-bg-accent"
                    type="image"
                    id="dropdownMenuButton1"
                    ref={profileBoxRef}
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <img alt="icon" src={headerIcon} className="img-fluid" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className=" p-0 user-dropdown"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <div
                      className="rightArrow"
                      style={{
                        display: "block",
                        border: "none",
                        top: "-6px",
                        right: "28px",
                      }}
                    ></div>
                    <Dropdown.ItemText>
                      <div className="profile-popup d-flex flex-column align-items-center justify-content-center">
                        <img
                          alt="icon"
                          src={headerIcon}
                          className=" user-avtar mb-3"
                        />
                        <span
                          className="fw-bolder text-wrap"
                          style={{ fontSize: "16px" }}
                          title={fullName}
                        >
                          {fullName}
                        </span>
                        <span
                          className=" text-steel text-wrap"
                          style={{ fontSize: "12px" }}
                          title={authReducer?.userData?.userName}
                        >
                          {" "}
                          {authReducer?.userData?.userName}
                        </span>
                        <div
                          style={{ color: "#6b7de5", marginTop: "5px" }}
                          className="d-flex justify-content-center h-100"
                        >
                          <img
                            src={exportImages?.icon_role_star}
                            style={{
                              marginRight: "6px",
                              height: "16px",
                              width: "16px",
                            }}
                          />
                          <span className="">
                            {authReducer?.userData?.role}{" "}
                          </span>
                        </div>
                        <div
                          className={
                            authReducer?.userData?.role === "Reseller" ||
                              authReducer?.userData?.role === "Bond-Admin"
                              ? "d-none"
                              : "d-flex justify-content-center h-100"
                          }
                        >
                          <span className="badge p-3">
                            {authReducer?.userData?.subscriptionName}
                          </span>
                        </div>

                        <div>
                          <label>
                            <b>Last Login :</b>
                          </label>
                          {authReducer?.userData
                            ? getDateMonthYearFormat(
                              moment
                                .utc(authReducer?.userData?.last_Login_At)
                                .format(),
                            )
                            : "NA"}
                        </div>
                      </div>
                    </Dropdown.ItemText>
                    <Dropdown.Divider />
                    <Dropdown.Item className="p-0 w-100">
                      <button
                        type="button"
                        class="btn btn-link w-100 menu-btn logout-button"
                        onClick={handleClickSettings}
                      >
                        <img
                          src={exportImages?.icons_settings}
                          className="img-default"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        <img
                          src={exportImages?.icons_settings_bule}
                          className="img-hover"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        Settings
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item className="p-0 w-100">
                      <button
                        type="button"
                        class="btn btn-link w-100 menu-btn logout-button"
                        onClick={() =>
                          window.open(
                            "https://www.bond.ai/autopilot/privacy-policy",
                            "_blank",
                          )
                        }
                      >
                        <img
                          src={exportImages?.icons_privacy_policy}
                          className="img-default"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        <img
                          src={exportImages?.icons_privacy_policy_blue}
                          className="img-hover"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        Privacy Policy
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item className="p-0 w-100">
                      <button
                        type="button"
                        class="btn btn-link w-100 menu-btn logout-button"
                        onClick={() => LogoutHandler()}
                      >
                        <img
                          src={exportImages?.power_button}
                          className="img-default"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        <img
                          src={exportImages?.power_button_blue}
                          className="img-hover"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        Logout
                      </button>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Container>
          </Navbar>
        </div>
        {hasSubscription(PRIVILEGES.SHOW_BANNER_NOTIFICATION) &&
          // (userRole?.toLowerCase() !== USER_TYPE.USER.toLowerCase() &&
          // userRole?.toLowerCase() !== USER_TYPE.ADMIN.toLowerCase()
          //   ? !currentPath.includes("/pages/faq") &&
          //     !currentPath.includes(
          //       "/bank/user-management/user-management-list",
          //     )
          //   : true) &&
          // !currentPath.includes("/user/bankperformancemetrics") &&
          // !currentPath.includes("/user/pricingTable") &&
          // !currentPath.includes("/pages/settings") &&
          currentPath.includes("/health-analysis/report/") &&
          !currentPath.includes("/financial-health-score") &&
          !currentPath.includes("/drilldown/") &&
          !currentPath.includes("/InsightsAndRecommendation") &&
          !currentPath.includes("/top_merchant_detailed_view") &&
          showBannerNotification && (
            <BannerNotification
              newAnalysis={newAnalysis}
              setNewAnalysis={setNewAnalysis}
            />
          )}
      </div>
      <UpgradeCardSpecificModal
        show={upgradeCardModal}
        onHide={() => setUpgradeCardModal(false)}
        cardData={selectedCardData}
      />
      <ImageAndDataPopUp
        show={forceLogout}
        // onHide={() => setInsightsModal(false)}
        modalData={paymentSuccessfulData}
      />
    </>
  );
};
